import { useNavigate } from "react-router-dom";
import useSearchLinkInfrastructure from '../infrastructure/hooks/useSearchLinkInfrastructure';
import { SearchLinkFormInterface } from '../domain';
import { useEffect } from "react";

const useSearchLink = () => {
    const navigate = useNavigate();
    const {
        setFormDataInfrastructure,
        submitRegistrationInfrastructure,
        resetRegistrationStateInfrastructure,
        searchLinkState
    } = useSearchLinkInfrastructure();

    useEffect(() => {
        resetRegistrationStateInfrastructure();
    }, []);

    useEffect(() => {
        if (searchLinkState.success && searchLinkState.responseSearchLink.link) {
            resetRegistrationStateInfrastructure();
            navigate('/success/' + searchLinkState.responseSearchLink.link);
        }

    }, [searchLinkState.success, searchLinkState.responseSearchLink])

    const setFormData = (formData: Partial<SearchLinkFormInterface>) => {
        setFormDataInfrastructure(formData);
    }

    const handleSubmit = () => {
        submitRegistrationInfrastructure();
    }

    return {
        setFormData,
        handleSubmit,
        data: searchLinkState
    }
}

export default useSearchLink
